export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9849.62d40acf.jpg";